export enum CheckOutStateEnum {
    INIT = "INIT",
    LOADING = "LOADING",
    READY = "READY",
    ERROR = "ERROR"
  };
  
  export type CheckOutStateType = `${CheckOutStateEnum}`